// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-table__cell-value[data-v-43e2b21a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.c-table__cell-value > a[data-v-43e2b21a] {\n    white-space: nowrap;\n}\n.fine-tooltip[data-v-43e2b21a] {\n  max-width: 250px;\n}\n", ""]);
// Exports
module.exports = exports;
